<template>
  <Catalog
    title="Статус проекта"
    name-label="Название статуса"
    submit-error="Укажите название статуса проекта."
    :fetch-data="fetchData"
    :put-data="putData"
    :post-data="postData"
    v-on="$listeners"
  />
</template>

<script>
import catalogs from "../../../network/catalogs";
  import Catalog from "../Catalog.vue";

export default {
  name: "ProjectStatus",
  components: { Catalog },
  mixins: [ catalogs ],
  methods: {
    async fetchData(id) {
      return await this.getProjectStatusById(id);
    },
    async putData(data) {
      return await this.putProjectStatus(data)
    },
    async postData(data) {
      return await this.postProjectStatus(data)
    },
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/ProjectStatuses/ProjectStatus.vue